module.exports = __webpack_public_path__ + "img/awards_moneybag.4f0cc679.png";